import { render, staticRenderFns } from "./DiscountsTypes.vue?vue&type=template&id=7e99b54b&"
import script from "./DiscountsTypes.vue?vue&type=script&lang=js&"
export * from "./DiscountsTypes.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsTypes.vue?vue&type=style&index=0&id=7e99b54b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports